'use client';

import { createContext, ReactNode } from 'react';

export interface RuntimeConfig {
    azureAd: {
        clientId: string;
        authority: string;
        apiScope: string;
        redirectUri: string;
        postLogoutRedirectUri: string;
        applicationInsightsConnectionString?: string;
    };
}

export const RuntimeConfigContext = createContext<RuntimeConfig | undefined>(
    undefined,
);

export function RuntimeConfigProvider({
    config,
    children,
}: {
    config: RuntimeConfig;
    children: ReactNode;
}) {
    return (
        <RuntimeConfigContext.Provider value={config}>
            {children}
        </RuntimeConfigContext.Provider>
    );
}
